import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './auth.guard';
import { PatientComponent } from './pages/patient/patient-list/patient.component';
import { PatientResolver } from './pages/patient/patient.resolver';
import { HospitalComponent } from './pages/hospital/hospital.component';
import { UserComponent } from './pages/user/user.component';
import { UsersResolver } from './pages/user/user.resolver';
import { AppointmentComponent } from './pages/appointment/appointment.component';
import { UserProfileComponent } from './pages/settings/user-profile/user-profile.component';
import { ClicnicalCategoryComponent } from './pages/category/clicnical-category/clinical-category.component';
import { ClicnicalSubCategoryComponent } from './pages/category/clicnical-sub-category/clicnical-sub-category.component';
import { ClinicalCategoryResolver } from './pages/category/clicnical-category/clinicalcategory.resolver';
import { ClinicalSubCategoryResolver } from './pages/category/clicnical-sub-category/clicnical-sub-category.resolver';
import { HospitalSettingComponent } from './pages/settings/hospital-setting/hospital-setting.component';
import { SettingTabComponent } from './pages/settings/setting-tab/setting-tab.component';
import { AppointmentTabComponent } from './pages/settings/appointment-tab/appointment-tab.component';
import { AppointmentTypeResolver } from './pages/settings/appointment-tab/appointment-type/appointment-type.resolver';
import { ClinicalItemComponent } from './pages/category/clinical-item/clinical-item.component';
import { ClinicalItemResolver } from './pages/category/clinical-item/clinical-item.resolver';
import { MediclaimComponent } from './pages/settings/mediclaim/mediclaim.component';
import { MediclaimResolver } from './pages/settings/mediclaim/mediclaim.resolver';
import { OPDComponent } from './pages/opd/opd.component';
import { BillChargeResolver } from './pages/settings/hospital-setting/bill-charge/bill-charge.resolver';
import { DoctorSpecialityResolver } from './pages/settings/hospital-setting/doctor-speciality/doctor-speciality.resolver';
import { DoctorDropDownResolver } from './resolvers/doctorDropDown.resolver';
import { PatientDropDownResolver } from './resolvers/patientDropDown.resolver';
import { AppointmentTypeDropDownResolver } from './resolvers/appoitmentTypeDropDown.resolver';
import { PaymentTypeDropDownResolver } from './resolvers/paymentTypeDropDown.resolver';
import { DrugTabComponent } from './pages/settings/drug-tab/drug-tab.component';
import { GenericContentResolver } from './pages/settings/drug-tab/generic-content-list/generic-content.resolver';
import { DrugCompanyResolver } from './pages/settings/drug-tab/drug-company/drug-company.resolver';
import { DrugResolver } from './pages/settings/drug-tab/drug-list/drug.resolver';
import { ClinicalcategoryDropDownResolver } from './resolvers/clinicalcategoryDropDown.resolver';
import { BillchargeDropDownResolver } from './resolvers/billchargeDropDown.resolver';
import { BillNumberDropDownResolver } from './resolvers/billnumberDropDown.resolver';
import { AllergyDropDownResolver } from './resolvers/allergyDropDown.resolver';
import { EducationDropDownResolver } from './resolvers/educationDropDown.resolver';
import { SensitivityDropDownResolver } from './resolvers/sensitivityDropDown.resolver';
import { IpdTabComponent } from './pages/settings/ipd/ipdTab.component';
import { WardResolver } from './pages/settings/ipd/ward/ward.resolver';
import { OPDExitGuard } from './pages/opd/opd.guard';
import { RoomTypeResolver } from './pages/settings/ipd/room-type/room-type.resolver';
import { WardDropDownResolver } from './resolvers/wardDropDown.resolver';
import { RoomResolver } from './pages/settings/ipd/room/room.resolver';
import { BedResolver } from './pages/settings/ipd/bed/bed.resolver';
import { IpdComponent } from './pages/ipd/ipd.component';
import { ExternalEntitiesDropDownResolver } from './resolvers/externalEntitiesDropDown.resolver';
import { ipdFeatureGuard } from './guards/ipd-feature.guard';
import { DashBoardComponent } from './pages/dashboard/dashboard.component';
import { IpdManagementComponent } from './pages/ipd/ipd-management/ipd-management.component';
import { BillingReportComponent } from './pages/reports/billing-report/billing-report.component';
import { ReportListComponent } from './pages/reports/report-list/report-list.component';
import { IpdReportComponent } from './pages/reports/ipd-report/ipd-report.component';
import { PharmacyComponent } from './pages/pharmacy/pharmacy.component';


export const routes: Routes = [
  {
    path: 'hospital',
    component: HospitalComponent,
    // resolve: { HospitalData: HospitalResolver },
    data: {
      title: 'Hospital',
    },
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashBoardComponent,
        title: 'Dashboard',
      },
      {
        path: 'patient',
        component: PatientComponent,
        title: 'Patient',
        resolve: {
          patientData: PatientResolver,
          ddleducation: EducationDropDownResolver,
          ddlallergy: AllergyDropDownResolver,
          ddlsensitivity: SensitivityDropDownResolver,
          ddlDoctor: DoctorDropDownResolver,
          ddlExternalEntities: ExternalEntitiesDropDownResolver
        },
      },
      {
        path: 'opd/:patientId/consultation',
        children: [
          {
            path: '',
            component: OPDComponent,
            canDeactivate: [OPDExitGuard],
            resolve: {
              ddlBillCharge: BillchargeDropDownResolver,
            },
            title: 'OPD',
            data: {
              title: 'OPD',
              urls: [
                { title: 'Dashboard', url: '/starter' },
                { title: 'OPD' },
              ],
            },
          },
          {
            path: ':opdId',
            component: OPDComponent,
            canDeactivate: [OPDExitGuard],
            resolve: {
              categoryData: ClinicalCategoryResolver,
              subcategoryData: ClinicalSubCategoryResolver,
              ddlBillCharge: BillchargeDropDownResolver,
            },
            title: 'OPD',
            data: {
              title: 'OPD',
              urls: [
                { title: 'Dashboard', url: '/starter' },
                { title: 'OPD' },
              ],
            },
          }
        ]
      },
      {
        path: 'user',
        component: UserComponent, //change componenet
        resolve: {
          userData: UsersResolver,
        },
        data: {
          title: 'User',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'User' },
          ],
        },
      },
      {
        path: 'hospital',
        component: HospitalComponent, //change componenet
        // resolve: { patientData: PatientResolver }, 
        data: {
          title: 'Hospital',
          urls: [
            { title: 'Hospital' },
          ],
        },
      },
      {
        path: 'appointment',
        component: AppointmentComponent, //change componenet
        title: 'Appointment',
        resolve: {
          ddlDoctor: DoctorDropDownResolver,
          ddlPatient: PatientDropDownResolver,
          ddlAppointmentType: AppointmentTypeDropDownResolver,
          ddlbillcharge: BillchargeDropDownResolver,
        },
      },
      {
        path: 'appointment/:patientId/patient',
        component: AppointmentComponent,
        title: 'Appointment',
        resolve: {
          patientData: PatientResolver,
          ddlDoctor: DoctorDropDownResolver,
          ddlPatient: PatientDropDownResolver,
          ddlAppointmentType: AppointmentTypeDropDownResolver,
          ddlPaymentType: PaymentTypeDropDownResolver,
          ddlbillcharge: BillchargeDropDownResolver,
          ddlbillnumber: BillNumberDropDownResolver,
          ddlallergy: AllergyDropDownResolver,
          ddlsensitivity: SensitivityDropDownResolver,
          ddleducation: EducationDropDownResolver
        },
      },
      {
        path: 'userprofile',
        component: UserProfileComponent,
        // data: {
        title: 'Userprofile',
      },
      {
        path: 'hospitalsetting',
        component: HospitalSettingComponent, //change componenet
        resolve: {
          billChargedata: BillChargeResolver,
          doctorSpecialityData: DoctorSpecialityResolver,
          // paymenttypedata:PaymentTypeResolver
        },
        data: {
          title: 'Hospital',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'Hospital' },
          ],
        },
      },
      {
        path: 'settings',
        component: SettingTabComponent,
        title: 'Settings', // header Title
        data: {
          title: 'Settings', // breadcrumb Title
          urls: [
            { title: 'Settings' },
          ],
        },
      },
      //======================== clinical ========================
      {
        path: 'clinical',
        children: [
          {
            path: 'clinicalcategory',
            component: ClicnicalCategoryComponent,
            resolve: { categoryData: ClinicalCategoryResolver },
            title: 'Clinical Category',
            data: {
              title: 'Clinical Category',
              urls: [
                { title: 'Settings', url: '/settings' },
                { title: 'Clinical Category' }
              ],
            },
          },
          {
            path: 'category/:categoryid/clinicalsubcategory',
            component: ClicnicalSubCategoryComponent,
            resolve: {
              subcategoryData: ClinicalSubCategoryResolver,
              ddlcategory: ClinicalcategoryDropDownResolver
            },
            title: 'Clinical SubCategory',
            data: {
              title: 'Clinical SubCategory',
              urls: [
                { title: 'Settings', url: '/settings' },
                { title: 'Clinical Category', url: '/clinical/clinicalcategory' },
                { title: 'Clinical SubCategory' }
              ],
            },
          },
          {
            path: 'category/:categoryid/subcategory/:id/clinicalitem',
            component: ClinicalItemComponent,
            resolve: {
              itemdata: ClinicalItemResolver,
            },
            title: 'Clinical Item',
            data: {
              title: 'Clinical Item',
              urls: [
                { title: 'Settings', url: '/settings' },
                { title: 'Clinical Category', url: '/clinical/clinicalcategory' },
                { title: 'Clinical SubCategory', url: '/clinical/category/:categoryid/clinicalsubcategory' },
                { title: 'Clinical Item' }
              ],
            },
          },
          {
            path: 'category/:categoryid/clinicalitem',
            component: ClinicalItemComponent,
            resolve: { itemdata: ClinicalItemResolver },
            data: {
              title: 'Clinical Item',
              urls: [
                { title: 'Settings', url: '/settings' },
                { title: 'Clinical Category', url: '/clinical/clinicalcategory' },
                { title: 'Clinical Item' }
              ],
            },
          },
        ],
      },
      {
        path: 'appointmenttab',
        component: AppointmentTabComponent,
        resolve: {
          appointmenttypedata: AppointmentTypeResolver,
          ddlbillcharge: BillchargeDropDownResolver,

        },
        title: 'AppointmentType',
        data: {
          title: 'AppointmentType',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'AppointmentType' }
          ],
        },
      },
      {
        path: 'Mediclaim',
        component: MediclaimComponent,
        resolve: {
          mediclaimdata: MediclaimResolver,
        },
        title: 'Mediclaim',
        data: {
          title: 'Mediclaim',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'Mediclaim' }
          ],
        },
      },
      {
        path: 'Drug',
        component: DrugTabComponent,
        resolve: {
          genericContentData: GenericContentResolver,
          DrugCompanyData: DrugCompanyResolver,
          drugData: DrugResolver,
        },
        title: 'Drug',
        data: {
          title: 'Drug',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'Drug' }
          ],
        },
      },
      {
        path: 'ipd/management',
        component: IpdManagementComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          ddlward: WardDropDownResolver,
          ddlDoctor: DoctorDropDownResolver,
        },
        title: 'IPD Management',
      },
      {
        path: 'pharmacy',
        component: PharmacyComponent,
        resolve: {
          ddlPatient: PatientDropDownResolver,
          ddlDoctor: DoctorDropDownResolver,
        },
        title: 'Pharmacy',
      },
      {
        path: 'reports/billing',
        component: BillingReportComponent,
        title: 'Billing Report',
      },
      {
        path: 'ipd',
        component: IpdTabComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          warddata: WardResolver,
        },
        title: 'IPD',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      },
      {
        path: 'ipd/ward/:wardId',
        component: IpdTabComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          roomtypeData: RoomTypeResolver,
          ddlbillcharge: BillchargeDropDownResolver,
        },
        title: 'Room Type',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      },
      {
        path: 'ipd/ward/:wardId/Roomtype/:roomTypeId',
        component: IpdTabComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          roomdata: RoomResolver,
        },
        title: 'Room',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      },
      {
        path: 'ipd/ward/:wardId/Roomtype/:roomTypeId/Room/:roomId',
        component: IpdTabComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          beddata: BedResolver,
        },
        title: 'Bed',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      },
      {
        path: 'ipd/admit/:ipdId/patient/:patientId',
        component: IpdComponent,
        canActivate: [ipdFeatureGuard],
        resolve: {
          ddlbillcharge: BillchargeDropDownResolver,
        },
        title: 'IPD',
        data: {
          title: 'IPD',
          urls: [
            { title: 'Settings', url: '/settings' },
            { title: 'IPD' }
          ],
        },
      },
      {
        path: 'reports/opd',
        component: ReportListComponent,
        title: 'OPD Reports',
      },
      {
        path: 'reports/ipd',
        component: IpdReportComponent,
        canActivate: [ipdFeatureGuard],
        title: 'IPD Reports',
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'authentication/error404',
    pathMatch: 'full',
  },

];
